import React, { Suspense, lazy } from 'react'
import { Routes, Route } from "react-router-dom";
import LoadingSpinner from "../Components/LoadingSpinner";

// Lazy Load Pages
const Home = lazy(() => import('../Content/Home'));
const ShareResume = lazy(() => import('../Content/ShareResume'));
const GalleryPage = lazy(() => import('../Content/GalleryPage'));
const VideoPage = lazy(() => import('../Content/VideoPage'));

const MainNavigator = () => {
    return (
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="*" element={<Home />}></Route>
          <Route path="/" element={<Home />}></Route>
          <Route path="/:userIdentifier" element={<Home />}></Route>
          <Route path="/:userIdentifier/share" element={<ShareResume />}></Route>
          <Route path="/:userIdentifier/gallery" element={<GalleryPage />} />
          <Route path="/:userIdentifier/work-video" element={<VideoPage />} />
        </Routes>
      </Suspense>
    );
}

export default MainNavigator